import { render, staticRenderFns } from "./WizardConfirmation.vue?vue&type=template&id=7c1ca4ec"
import script from "./WizardConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardConfirmation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports